import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName } from '../../constants';

export class GATrackingPdpDescriptionInteractionEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): any {
    return this.payload.action;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PdpDescriptionInteraction,
      label: this.payload.label,
      gtmCustom: {
        category: this.payload.category
      }
    };
  }
}
